export function getOffsets(data) {
  const { firstColumnAsCategories, firstRowAsNames } = data;
  const [seriesOffset, categoryOffset] = [firstColumnAsCategories, firstRowAsNames].map(getOffset);
  return { seriesOffset, categoryOffset };
}

function getOffset(prop) {
  return prop ? 1 : 0;
}

